<template>
  <a-modal 
  :width="700"
  maskClosable
  centered
  :footer="null"
  :visible="visible"
  title="草稿箱" 
  @cancel="cancel">
    <div class="draft-box">
      <p class="tip-text">系统将为您保存最近10条草稿</p>
      <a-table :columns="columns" :data-source="list" rowKey="id" :pagination="false">
        <div class="draft-title text-ellipsis" slot="artTitle" slot-scope="text,record" @click="clickItem(record)" :title="text">{{ text }}</div>
        <div slot="createTime" slot-scope="text" >{{ formatTime(text) }}</div>
        <div class="draft-del" slot="opreation" slot-scope="text,record,index" @click="delItem(index)">删除</div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { cloneDeep, formatTime } from '@/utils'

export default {
  name: 'DraftBox',
  props: {
    // 显示隐藏
    value: {
      type: Boolean, 
      default: false,
    },
    // 草稿列表
    list: {
      type: Array
    }
  },
  data() {
    return {
      visible: false,
      columns: [
        { 
          title: '标题',
          dataIndex: 'title',
          key: 'title',
          width: 300,
          ellipsis: true,
          scopedSlots: { customRender: 'artTitle' },
        },
        { 
          title: '保存时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 200,
          scopedSlots: { customRender: 'createTime' },
        },
        { 
          title: '操作',
          dataIndex: 'opreation',
          key: 'opreation',
          width: 100,
          align: 'right',
          scopedSlots: { customRender: 'opreation' }
        }
      ],
    }
  },
  watch: {
    value(n) {
      this.visible = n
    }
  },
  methods: {
    formatTime,
    // 点击使用草稿
    clickItem(item) {
      this.$confirm({
        title: '页面内容将覆盖',
        content: '当前页面编辑的内容将被草稿内容覆盖，无法恢复，请确认',
        onOk: ()=> {
          this.$emit('change', cloneDeep(item))
          this.cancel()
        },
      })
    },
    // 删除草稿
    delItem(i) {
      this.$emit('delete', i)
    },
    cancel() {
      this.$emit('input',false)
    }
  }
}
</script>
<style lang="less" scoped>
.draft-box {
  position: relative;

  .draft-title {
    color: #1740DC;
    cursor: pointer;
  }
  .draft-del {
    cursor: pointer;
    &:hover {
      color: red;
    }
  }
  .tip-text {
    margin: 5px 0 10px;
    font-size: 12px;
    color: rgba(4,12,44,0.45);
    line-height: 18px;
    font-weight: 400;
  }
}
</style>